import $ from 'jquery';
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CssLoader from '../../components/cssloader/CssLoader';
import CustomPagination from '../../common/Pagination';
import CustomTab from "../../common/Tab";
import Sidebar from "../../components/Sidebar";
import { IMatchData } from "../../helpers/interfaces/matchData";
import { ICategoryArticle } from "../../helpers/interfaces/ranking";
import { matchesService } from '../../services/MatchesService';
import { Article } from '../Categorie/Categoria/Article';
import CategoryGroupMatchesTable from './CategoryGroupMatchesTable';
import SelectMatchesDate from './SelectMatchesDate';
import SendResultModal from './SendResultModal';
import Advertising from '../../common/Advertising';
import { CategoryGroup, CategoryMatch, TodayMatch } from '../../helpers/interfaces/category';
import "./PartiteOdierne.css";
import PageMeta from "../../components/PageMeta";


export default function PartiteOdiernePage() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isShown, setIsShown] = useState(false);
    const [openResultsModal, setOpenResultsModal] = useState(false);
    const [currentDate, setCurrentDate] = useState<Date>(new Date());
    const [currentCategory, setCurrentCategory] = useState<TodayMatch | undefined>(undefined);
    const [currentCategoryId, setCurrentCategoryId] = useState<string | undefined>(undefined);
    const [currentMatch, setCurrentMatch] = useState<IMatchData | undefined>(undefined);
    const [matches, setMatches] = useState<TodayMatch[]>([]);
    const [matchesCategoryGroup, setMatchesCategoryGroup] = useState<CategoryGroup[]>([])
    const [articles, setArticles] = useState<ICategoryArticle[]>([]);
    const [currentArticles, setCurrentArticles] = useState<ICategoryArticle[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const setCellsWidth = () => {
        let tableWidth = $('table > tbody.tbody-mobile').width()
        let count = $("table > tbody.tbody-mobile > tr:first > td").length;
        if (count === 4 && tableWidth) {
            $("table > tbody.tbody-mobile > tr > td[data-index='0']").css({ width: (tableWidth / 100 * 20) })
            $("table > tbody.tbody-mobile > tr > td[data-index='1']").css({ width: (tableWidth / 100 * 50) })
            $("table > tbody.tbody-mobile > tr > td[data-index='2']").css({ width: (tableWidth / 100 * 15) })
            $("table > tbody.tbody-mobile > tr > td[data-index='3']").css({ width: (tableWidth / 100 * 15) })
        }
        if (count === 3 && tableWidth) {
            $("table > tbody.tbody-mobile > tr > td[data-index='0']").css({ width: (tableWidth / 100 * 25) })
            $("table > tbody.tbody-mobile > tr > td[data-index='1']").css({ width: (tableWidth / 100 * 50) })
            $("table > tbody.tbody-mobile > tr > td[data-index='2']").css({ width: (tableWidth / 100 * 25) })
        }
    }

    useEffect(() => {
        $('.send-results-btn').off().on('click', async (e: { currentTarget: { id: string } }) => {
            const matchId = e.currentTarget.id.split("-").pop();
            if (matchId) {
                setIsLoading(true);

                try {
                    const selectedMatch = await matchesService.getMatch(matchId);
                    if (selectedMatch && typeof selectedMatch !== "string") {
                        let currentMatch = { ...selectedMatch }
                        const teamA = await matchesService.getTeamData(selectedMatch.idSquadraA.toString());
                        const teamB = await matchesService.getTeamData(selectedMatch.idSquadraB.toString());
                        if (teamA && typeof teamA !== "string" && teamA !== undefined)
                            currentMatch.giocatoriA = teamA.giocatori.filter(player => Boolean(player.attivo))
                        if (teamB && typeof teamB !== "string" && teamB !== undefined)
                            currentMatch.giocatoriB = teamB.giocatori.filter(player => Boolean(player.attivo))
                        setCurrentMatch(currentMatch);
                        setOpenResultsModal(true);
                    }
                } finally {
                    setIsLoading(false);
                }
            }
        });

        setCellsWidth();

        $(window).on('resize', function () {
            let width = $(window).width();
            if (width && width < 540) {
                setCellsWidth()
            }
            if ($(this).width() !== width) {
                width = $(this).width();
            }
        });
    })

    const fetchArticles = useCallback(async (categoryId: string) => {
        try {
            const articles = await matchesService.getCategory(categoryId);
            if (articles && typeof articles !== "string" && categoryId) {
                setArticles(articles.ultimiPerCategoria)
                const showArticles = articles?.ultimiPerCategoria.slice(0, 8)
                if (showArticles)
                    setCurrentArticles(showArticles)
            }
        } finally {
            setIsLoading(false);
        }
    }, [])

    const fetchMatches = useCallback(async (date: Date) => {
        try {
            const matches = await matchesService.getMatchesByDay(date.toLocaleDateString());
            if (matches && typeof matches !== "string") {
                setMatches(matches);
                
                if (matches.length > 0){
                    setCurrentCategoryId(matches[0].idCategoria);
                }
            }
        } finally {
            setIsLoading(false);
        }
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            await fetchMatches(currentDate);
        }

        fetchData();
    }, [currentDate, fetchMatches]);

    const selectCategory = useCallback(async(categoryId: string) => {
        const category = matches.find(match => match.idCategoria === categoryId)
        if (category) {
            setCurrentCategory(category)
            setCurrentCategoryId(category.idCategoria)
        }
    }, [matches]);

    useEffect(() => {
        (async() => {
            if (currentCategoryId && matches && matches.length > 0) {
                await selectCategory(currentCategoryId);
            }
            
            if (currentCategoryId) {
                setIsLoading(true);

                await fetchArticles(currentCategoryId)
            }

        })();
    }, [matches, currentCategoryId, fetchArticles, selectCategory]);

    useEffect(() => {
        if (currentCategory && matches.length > 0) {
            const matchs = currentCategory.partite;
            let matchesByCategoryGroup: CategoryGroup[] = [];

            matchs.forEach((
                match: CategoryMatch
            ) => {
                let group = matchesByCategoryGroup.find((groupItem) => {
                    return groupItem.idGirone === match.idGirone 
                });

                if (!group) {
                    const groupIndex = matchesByCategoryGroup.push({
                        idGirone: match.idGirone,
                        nomeGirone: match.nomeGirone,
                        numeroPartite: 0,
                        partite: []
                    });

                    group = matchesByCategoryGroup[groupIndex - 1];
                }

                group.numeroPartite = group.numeroPartite++;
                group.partite.push(match);
            });
            setMatchesCategoryGroup(matchesByCategoryGroup)
        }
    }, [currentCategory, matches])

    const onDateChange = async (value: string) => {
        setIsLoading(true);

        setCurrentDate(new Date(value));
    }

    const onPageChange = (e: number) => {
        setCurrentPage(e);
        const start = (e - 1) * 8
        const end = start + 8
        const showArticles = articles.slice(start, end);
        if (showArticles)
            setCurrentArticles(showArticles);
    }

    return <div className='matches-content'>
        <PageMeta
            title={`Partite del ${currentDate.toLocaleDateString()} - Calcio a 5 Live`}
            description=""
            image=""
            url={document.location.href}
            type=""
        />
        <SendResultModal
            showModal={openResultsModal}
            currentMatch={currentMatch}
            onCloseHandler={() => {
                setOpenResultsModal(false)
            }}
        />
        <h1>Partite odierne - {currentDate.toLocaleDateString()}</h1>
        {
            matches.length > 0 &&
            <div className='position-relative'>
                <SelectMatchesDate isShown={isShown} setIsShown={setIsShown} onDateChange={onDateChange} currentDate={currentDate} />
                {
                    matches.length > 0 ? <CustomTab
                        id="tab_matches_categories"
                        activeKey={`tab_matches_categories_${currentCategoryId}`}
                        selectTitle='Categoria'
                        panels={
                            matches.map(
                                category => {
                                    return {
                                        id: `tab_matches_categories_${category.idCategoria}`,
                                        name: category.nomeCategoria + ` (${category.numeroPartite})`,
                                        element: <div className="mt-3">
                                            <h3>{category.nomeCategoria + ` (${category.numeroPartite})`}</h3>
                                            {
                                                matchesCategoryGroup && matchesCategoryGroup.length ? matchesCategoryGroup.map((
                                                    categoryGroup: CategoryGroup,
                                                    index: number
                                                ) => {
                                                    return <div className="matches_table_group fs-6" key={index}>
                                                        {categoryGroup.partite && categoryGroup.partite.length > 0
                                                            ? <><CategoryGroupMatchesTable
                                                                category={category}
                                                                currentCategory={currentCategory}
                                                                group={categoryGroup.nomeGirone}
                                                                groupId={categoryGroup.idGirone}
                                                                matchesCategory={categoryGroup.partite} />
                                                            <hr /></> : <Row className="pb-3 d-flex justify-content-center">
                                                                Nessuna partita presente
                                                            </Row>
                                                        }
                                                    </div>
                                                }) : <Row className="pb-3 d-flex justify-content-center">
                                                    Nessuna partita presente
                                                </Row>
                                            }
                                        </div>
                                    }
                                }
                            )
                        }
                        onChange={(index) => selectCategory(matches[index].idCategoria)}
                    /> : <Row className="pb-3 d-flex justify-content-center">Nessuna categoria trovata</Row>
                }
            </div>
        }

        <hr />
        <Advertising code="banner-cat4" as="div" />
        <Row id="page_content">
            <Col id="content" xs={12} lg={9}>
                <h3 className="mt-2 mb-4">Potrebbe interessarti anche...</h3>
                {
                    currentArticles.length > 0 ? currentArticles.map((article, index) => {
                        if (index !== 0 && index % 3 === 0) {
                            return <React.Fragment key={article.id + "-" + index}>
                                <Article key={article.id} article={article} />
                                {index === 3 && <Advertising code="banner-cat5" as="div" />}
                                {index === 6 && <Advertising code="banner-cat6" as="div" />}
                            </React.Fragment>
                        }
                        return <Article key={article.id} article={article} />
                    }) : <Row className="pb-3 d-flex justify-content-center">Nessuna informazione trovata</Row>
                }
                <div className="d-flex justify-content-center">
                    <CustomPagination
                        totalRecords={articles.length || 0}
                        pageLimit={8}
                        pageNeighbours={2}
                        onPageChanged={onPageChange}
                        currentPage={currentPage}
                    />
                </div>
            </Col>
            <Col id="sidebar" xs={12} lg={3}>
                <Sidebar />
            </Col>
        </Row>

        <CssLoader active={isLoading} text="Caricamento delle partite odierne in corso..." />
    </div>
}